import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/app/StatusBadge";
import { api, formatApiError } from "@/lib/api";

const FILTERS = [["open", "Terbuka"], ["resolved", "Selesai"], ["all", "Semua"]];
const fmt = (d) => new Date(d).toLocaleString("ms-MY");

const ErrorRow = ({ e, onResolve }) => (
  <div className="space-y-2 p-4 text-sm" data-testid={`error-row-${e.id}`}>
    <div className="flex flex-wrap items-start justify-between gap-2">
      <span className="flex min-w-0 flex-wrap items-center gap-2">
        <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${e.source === "frontend" ? "bg-amber-100 text-amber-800" : "bg-rose-100 text-rose-800"}`}>{e.source === "frontend" ? "Pelayar" : "Pelayan 500"}</span>
        <strong className="break-all">{e.message}</strong>
      </span>
      {e.status === "open"
        ? <Button size="sm" variant="outline" className="rounded-xl text-emerald-700" onClick={() => onResolve(e)} data-testid={`error-resolve-${e.id}`}>Tandakan selesai</Button>
        : <span className="text-xs font-semibold text-emerald-700">Selesai · {e.resolved_by}</span>}
    </div>
    <p className="text-xs text-slate-500" data-testid={`error-meta-${e.id}`}>
      <b>{e.count}</b> kejadian · <b>{(e.users || []).length}</b> pengguna terjejas · {e.path || "-"} · pertama {fmt(e.first_seen)} · terakhir {fmt(e.last_seen)}
    </p>
    {!!(e.users || []).length && <p className="text-xs text-slate-500">Pengguna: {e.users.slice(0, 10).join(", ")}{e.users.length > 10 && " …"}</p>}
    {e.stack && <details><summary className="cursor-pointer text-xs text-violet-700">Lihat jejak ralat</summary><pre className="mt-2 max-h-60 overflow-auto rounded-lg bg-slate-900 p-3 text-[11px] text-slate-100">{e.stack}</pre></details>}
  </div>
);

export const ErrorReports = () => {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("open");
  const load = () => api.get("/admin/errors", { params: { status: filter } }).then((r) => setItems(r.data)).catch((e) => toast.error(formatApiError(e)));
  useEffect(() => { load(); }, [filter]); // eslint-disable-line react-hooks/exhaustive-deps
  const resolve = async (e) => {
    try { await api.post(`/admin/errors/${e.id}/resolve`); toast.success("Ralat ditandakan selesai"); load(); }
    catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <div className="space-y-3" data-testid="admin-errors">
      <p className="text-sm text-slate-500">Ralat dilaporkan secara automatik. Emel dihantar kepada Super Admin dan support@minitai.app, maksimum sekali sejam bagi ralat yang sama. Ralat yang berulang selepas ditandakan selesai akan dibuka semula.</p>
      <div className="flex gap-2">{FILTERS.map(([k, l]) => <Button key={k} size="sm" variant={filter === k ? "default" : "outline"} className="rounded-xl" onClick={() => setFilter(k)} data-testid={`errors-filter-${k}`}>{l}</Button>)}</div>
      <Card className="max-h-[640px] divide-y divide-slate-100 overflow-y-auto">
        {!items.length && <p className="p-6 text-sm text-slate-500" data-testid="errors-empty">Tiada ralat.</p>}
        {items.map((e) => <ErrorRow key={e.id} e={e} onResolve={resolve} />)}
      </Card>
    </div>
  );
};
